export default __webpack_public_path__ + "static/media/N3.9428179d.png";